<template>
  <div class="content conteudo">
    <h1><span><i class="fas fa-book"></i> Editar simulado</span></h1>

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1">Detalhes do simulado</h2>
      </div>
      <div class="col-12 col-md-6 text-center text-md-right">
        <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="redirectToSimulado()"><i class="fas fa-chevron-left"></i> Voltar e cancelar</a>
      </div>
    </div>

    <simulados-edicao ref="cadastrar" :simulado_atual="simulado_atual"
                                      :publicoAlvo="publicoAlvo"
                                      :fontes="fontes"
                                      :modalidades="modalidades"
                                      :cursos="cursos"
                                      :tiposSimulados="tiposSimulados" />

  </div>
</template>

<script>
import SimuladosEdicao from '@/modules/Conteudo/components/SimuladosEdicao'

export default {
  name: 'EditarSimuladoView',
  components: { SimuladosEdicao },
  props: {
    simulado_atual: Object,
    publicoAlvo: Array,
    fontes: Array,
    modalidades: Array,
    cursos: Array,
    tiposSimulados: Array
  },
  methods: {
    redirectToSimulado: function () {
      this.$router.push('/conteudo/simulados')
    }
  }
}
</script>
